"use client";

import { Testimonial } from "@prisma/client";
import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";

const Testimonials = ({ testimonials }: { testimonials: Testimonial[] }) => {
  const [index, setIndex] = useState(0);
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  //   }, 10000);
  //   return () => clearInterval(interval);
  // }, [testimonials.length]);

  const variants = {
    enter: { opacity: 0, x: -100 },
    center: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
  };

  return (
    <AnimatePresence>
      <div className="mt-16">
        {testimonials.map(
          (testimonial) =>
            testimonials[index].id === testimonial.id && (
              <motion.div
                key={testimonial.id}
                variants={variants}
                initial="enter"
                animate="center"
                exit="exit"
                transition={{
                  opacity: { duration: 0.5 },
                  x: { type: "tween", duration: 0.5 },
                }}
              >
                <div className="w-4/5 m-auto top-0 my-4 mb-8 border-l-2 px-4 text-slate-500">
                  <div>{testimonial.text}</div>
                  <div className="text-xs">- {testimonial.author}</div>
                </div>
              </motion.div>
            )
        )}
      </div>
    </AnimatePresence>
  );
};

export default Testimonials;
